module.exports = __webpack_public_path__ + "img/logo-bg.6fbf4b3a.jpg";